import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNewsFallbackIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 80,
	height: 74,
	viewBox: "0 0 80 74",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M60.9597 28.51C63.3932 26.366 64.0807 22.7113 62.3981 19.7983C60.7154 16.8854 57.2145 15.646 54.1387 16.6864L60.9597 28.51Z",
			fill: "#FF3131"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M78.6545 28.5458C79.6768 28.8805 80.2376 29.9751 79.9029 30.9974C79.5682 32.0196 78.4736 32.5805 77.4513 32.2458L70.3589 29.9389C69.3367 29.6042 68.7758 28.5096 69.1105 27.4874C69.4453 26.4651 70.5399 25.9042 71.5621 26.239L78.6545 28.5458Z",
			fill: "#FF3131"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M70.6212 18.1062C69.6894 18.649 68.4953 18.3233 67.9525 17.3915C67.4097 16.4597 67.7354 15.2656 68.6672 14.7228L75.0721 11.0228C76.0038 10.48 77.198 10.8057 77.7407 11.7375C78.2835 12.6693 77.9579 13.8634 77.0261 14.4062L70.6212 18.1062Z",
			fill: "#FF3131"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M59.8385 1.7415C60.0647 0.69212 61.0959 0.0136384 62.1453 0.239799C63.1947 0.465959 63.8732 1.49725 63.647 2.54664L62.1001 9.8471C61.8739 10.8965 60.8426 11.575 59.7933 11.3488C58.7439 11.1226 58.0654 10.0914 58.2916 9.04197L59.8385 1.7415Z",
			fill: "#FF3131"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.11787 54.0209L1.41715 51.0717C-1.47771 46.051 0.25016 39.5737 5.27092 36.6789L12.7161 32.3818L26.6657 56.5358L19.2205 60.8328C14.1997 63.7277 7.7225 61.9998 4.82765 56.9791L3.12692 54.0299L3.11787 54.0209Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M16.0078 30.3193C27.0806 22.7112 34.6615 13.9362 39.9446 4.79025C40.2432 4.27461 40.7588 3.97607 41.3559 3.97607C41.9529 3.97607 42.4686 4.27461 42.7671 4.79025L65.5732 44.296C65.8717 44.8116 65.8717 45.3996 65.5732 45.9243C65.2746 46.44 64.759 46.7385 64.1619 46.7385C53.6047 46.7385 42.2153 48.9187 30.084 54.7084L16.0078 30.3193Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M31.2513 58.4805C30.8985 58.6524 30.5457 58.8242 30.1928 59.0052L22.6934 63.3384L32.4454 73.0904C33.3953 74.0403 34.9422 74.0403 35.8921 73.0904L39.1488 69.8337C40.0987 68.8839 40.0987 67.3369 39.1488 66.387L31.2513 58.4895V58.4805Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M62.389 19.78C60.7064 16.8851 57.2054 15.6458 54.1387 16.6861L57.5311 22.5572L62.3981 19.78H62.389Z",
			fill: "#F96262"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.93634 53.7221L19.5456 44.2324L12.6974 32.3726L5.26127 36.6696C0.240508 39.5645 -1.49641 46.0417 1.4075 51.0625L2.93634 53.7131V53.7221Z",
			fill: "#565656"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M54.1385 24.4931L42.7671 4.79904C42.4686 4.2834 41.9529 3.98486 41.3559 3.98486C40.7588 3.98486 40.2432 4.2834 39.9446 4.79904C34.6615 13.9359 27.0806 22.72 16.0078 30.328L22.9283 42.3145L54.1294 24.5021L54.1385 24.4931Z",
			fill: "#565656"
		})
	]
});
export default SvgNewsFallbackIcon;
